import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
} from '@mui/material';
import FormButtonGroup from '../layout/FormButtonGroup.jsx';

export default function DeleteDialog({
  open,
  handleClose,
  handleDelete,
  recordId,
  loading,
  recordDetails,
}) {
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{'Delete this record?'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {"Clicking 'Yes' will delete the record '"
              .concat(recordDetails.name)
              .concat(`' (ID: ${recordId})`)
              .concat('.')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <FormButtonGroup>
            <Button onClick={handleClose} autoFocus>
              No
            </Button>
            <Button onClick={handleDelete}>Yes</Button>
            {loading && (
              <CircularProgress
                size={24}
                color={'success'}
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  marginTop: '-12px',
                  marginLeft: '-12px',
                }}
              />
            )}
          </FormButtonGroup>
        </DialogActions>
      </Dialog>
    </div>
  );
}

DeleteDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  handleDelete: PropTypes.func,
  recordName: PropTypes.string,
  recordId: PropTypes.number,
  loading: PropTypes.bool,
  recordDetails: PropTypes.object,
};
